module.exports = __webpack_public_path__ + "img/bottom_bar.0a9be100.png";